import React, { useEffect, useState } from 'react'
import LayoutHeader from '../../layout/LayoutHeader'
import { useNavigate } from 'react-router'
import { useDispatch, useSelector } from 'react-redux'
import { setErrorAlert, setSuccessAlert, setLoader } from '../../store/alert/alertSlice'
import { postDataAPI, getDataAPI } from '../../utils/fetchData'

const EmailSearch = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { user } = useSelector((state) => state.auth)
    
    const [loading, setLoading] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [searchResults, setSearchResults] = useState([])
    const [isSearching, setIsSearching] = useState(false)

    const handleSearch = async () => {
        if (!searchQuery.trim()) return
        
        try {
            setIsSearching(true)
            dispatch(setLoader(true))
            
            const token = JSON.parse(localStorage.getItem('dizeeToken'))
            const response = await postDataAPI('user/gmail/search', {
                query: searchQuery.trim()
            }, token)
            
            if (response.data.status === 200) {
                setSearchResults(response.data.data.emails || [])
                if (response.data.data.emails.length === 0) {
                    dispatch(setSuccessAlert('No emails found matching your search'))
                }
            } else {
                dispatch(setErrorAlert('Failed to search emails'))
            }
        } catch (error) {
            console.error('Error searching emails:', error)
            dispatch(setErrorAlert('Error searching emails'))
        } finally {
            setIsSearching(false)
            dispatch(setLoader(false))
        }
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch()
        }
    }

    return (
        <LayoutHeader>
            <div className="w-[390px] flex flex-col justify-start items-center relative z-[0]">
                <div className="px-4 my-[50px] flex w-full justify-between">
                    <p className="text-white">Email Search</p>
                    <div className='flex gap-[20px]'>
                        <p onClick={() => navigate('/email')} className='text-white cursor-pointer'>Go back</p>
                    </div>
                </div>

                <div className="w-full px-4 space-y-4 pb-8">
                    {/* Search Interface */}
                    <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4">
                        <h3 className="text-white text-[14px] font-semibold mb-3">Search Your Emails</h3>
                        <div className="flex gap-2">
                            <input
                                type="text"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                onKeyPress={handleKeyPress}
                                placeholder="Search emails..."
                                className="flex-1 bg-[rgba(255,255,255,0.1)] border border-[rgba(255,255,255,0.2)] rounded-md px-3 py-2 text-white text-[12px] placeholder-[rgba(255,255,255,0.5)] focus:outline-none focus:border-[rgba(255,255,255,0.4)]"
                            />
                            <button
                                onClick={handleSearch}
                                disabled={isSearching || !searchQuery.trim()}
                                className="bg-[rgba(34,197,94,0.1)] border border-[rgba(34,197,94,0.3)] text-[#22C55E] text-[12px] px-4 py-2 rounded-md hover:bg-[rgba(34,197,94,0.2)] disabled:opacity-50 disabled:cursor-not-allowed transition-all"
                            >
                                {isSearching ? 'Searching...' : 'Search'}
                            </button>
                        </div>
                    </div>

                    {/* Search Results */}
                    {searchResults.length > 0 && (
                        <div className="space-y-3">
                            <h4 className="text-white text-[12px] font-semibold">Search Results ({searchResults.length})</h4>
                            {searchResults.map((email, index) => (
                                <div key={index} className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4">
                                    <div className="space-y-2">
                                        <div className="flex items-center justify-between">
                                            <p className="text-white text-[12px] font-medium truncate flex-1">
                                                {email.subject || 'No Subject'}
                                            </p>
                                            <span className="text-[rgba(255,255,255,0.6)] text-[10px] ml-2">
                                                {new Date(email.date).toLocaleDateString()}
                                            </span>
                                        </div>
                                        <p className="text-[rgba(255,255,255,0.7)] text-[10px]">
                                            From: {email.from}
                                        </p>
                                        {email.snippet && (
                                            <p className="text-[rgba(255,255,255,0.6)] text-[10px] leading-relaxed">
                                                {email.snippet}
                                            </p>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {/* No Results Message */}
                    {searchResults.length === 0 && searchQuery && !isSearching && (
                        <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4 text-center">
                            <p className="text-[rgba(255,255,255,0.6)] text-[12px]">
                                No emails found for "{searchQuery}". Try a different search term.
                            </p>
                        </div>
                    )}

                    {/* Search Suggestions */}
                    {!searchQuery && (
                        <div className="bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.1)] rounded-lg p-4">
                            <h4 className="text-white text-[12px] font-semibold mb-3">Search Examples</h4>
                            <div className="space-y-2 text-[11px] text-[rgba(255,255,255,0.6)]">
                                <p>• "booking confirmation"</p>
                                <p>• "collaboration request"</p>
                                <p>• "venue contact"</p>
                                <p>• "show opportunity"</p>
                                <p>• "record label"</p>
                            </div>
                        </div>
                    )}
                </div>


            </div>
        </LayoutHeader>
    )
}

export default EmailSearch 